import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GenerateUuid extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.generateuuid',
        group: 'Data Preparation',
        title: 'Generate UUID',
        description: `

      This component creates a new table with an additional UUID column.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return dedent`SELECT GENERATE_UUID() AS id, *
            FROM ${connection.quoteName(params.source as string)}`
      case Provider.Snowflake:
        return dedent`SELECT UUID_STRING() AS id, *
            FROM ${connection.quoteName(params.source as string)}`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */ UUID() AS id, *
            FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle:
        return dedent`SELECT RAWTOHEX(SYS_GUID()) AS "id", t.*
            FROM ${connection.quoteName(params.source as string)} t`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: 'id',
      type: ColumnDataType.String
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake, Provider.DatabricksRest, Provider.Oracle]
  }
}

export { GenerateUuid }
